import React, { ChangeEvent, FormEvent, useState } from "react";
import { ResetPwPg } from "./styled";
import topGraphic from "../../assets/top-graphic.png";
import axios from "axios";
import appConfig from "../../config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import routes from "../../routes";
import { useSearchParams } from "react-router-dom";

const SetNewPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const navigate = useNavigate();

  const handlePasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`${appConfig.API_URL}/users/create-password`, {
        user: token,
        password: password,
      })
      .then(({ status, data }) => {
        if (status === 200) {
          setPassword("");
          setConfirmPassword("");
          toast("You have successfully changed your password");
          setLoading(false);
          navigate(routes.login);
        }
      })
      .catch((err) => {
        toast(err.response.data.message);
        setLoading(false);
      });
  };

  const hasEmptyField = !(
    password.length &&
    confirmPassword.length &&
    password === confirmPassword
  );

  return (
    <ResetPwPg>
      <img className="top-graphic" src={topGraphic} alt="top graphic" />
      <div className="container pt-4">
        <h5 className="py-4">Create Your New Password</h5>
        <form className="w-75" onSubmit={handleSubmit}>
          <div className="py-2">
            <label htmlFor="password">New Password</label>
          </div>
          <div className="py-2">
            <input
              className="w-50"
              type="password"
              placeholder="Enter Your New Password"
              onChange={handlePasswordChange}
              value={password}
            />
          </div>
          <div className="py-2">
            <label htmlFor="password">Confirm Password</label>
          </div>
          <div className="py-2">
            <input
              className="w-50"
              type="password"
              placeholder="Confirm Your New Password"
              onChange={handleConfirmPasswordChange}
              value={confirmPassword}
            />
          </div>
          <div className="py-3">
            <button
              className="btn btn-danger w-50"
              disabled={hasEmptyField || loading}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </ResetPwPg>
  );
};

export default SetNewPassword;
